import { Box, Group, Stack, Text } from "@mantine/core";

import { NarrativeCardActions } from "../NarrativeCardActions/NarrativeCardActions";
import styles from "./NarrativeGuideWaiting.module.css";

export interface NarrativeGuideWaitingProps {
    /** Advance past the Guide step once the expert is done co-browsing. */
    onContinue?: () => void;
    /** Return to the send form to send the co-browse link again. */
    onResend?: () => void;
}

/**
 * The Guide step's post-send state — shown after the guided-browsing link is sent and the co-browse
 * dialog is up. Unlike the Enroll wait (which waits on an async enrollment-event and then flips the
 * whole surface), this holds the step for the EXPERT: they walk the customer through the coverage on
 * the shared screen, then click Continue to move on — whether or not they leave the co-browse dialog
 * open. Mirrors the shape of `NarrativeEnrollWaiting` so the two post-send states feel the same.
 */
export const NarrativeGuideWaiting = ({ onContinue, onResend }: NarrativeGuideWaitingProps) => (
    <div className={styles.card}>
        <Stack gap={12}>
            <Group gap={10} align="center" wrap="nowrap">
                <Box className={styles.liveDot} aria-hidden />
                <Text className={styles.heading}>Guided browsing is live</Text>
            </Group>
            <Text className={styles.sub}>
                Walk them through the coverage on their screen. Continue whenever you&apos;re ready — the co-browse
                stays open.
            </Text>
        </Stack>
        {/* Lower → higher emphasis: Re-send (link) first, then the single filled primary (Continue). */}
        <NarrativeCardActions>
            <NarrativeCardActions.Link onClick={onResend}>Re-send link</NarrativeCardActions.Link>
            <NarrativeCardActions.Primary onClick={onContinue}>Continue</NarrativeCardActions.Primary>
        </NarrativeCardActions>
    </div>
);
